import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface IOption {
  label: string;
  value: string;
}

interface InitialState {
  status: ReduxStateType;
  WORKING_AREA: IOption[];
  JOB_TITLE: IOption[];
  LEAVE_REASON: IOption[];
  DEPT_LEVEL1: IOption[];
  DEPT_LEVEL2: IOption[];
  TIMEKEEPING_TYPE: IOption[];
  LEAVE_REASON_TYPE: IOption[];
}

export enum CATEGORY_TYPE {
  WORKING_AREA = "WORKING_AREA",
  JOB_TITLE = "JOB_TITLE",
  LEAVE_REASON = "LEAVE_REASON",
  DEPT_LEVEL1 = "DEPT_LEVEL1",
  DEPT_LEVEL2 = "DEPT_LEVEL2",
  TIMEKEEPING_TYPE = "TIMEKEEPING_TYPE",
  LEAVE_REASON_TYPE = "LEAVE_REASON_TYPE",
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  [CATEGORY_TYPE.WORKING_AREA]: [],
  [CATEGORY_TYPE.JOB_TITLE]: [],
  [CATEGORY_TYPE.LEAVE_REASON]: [],
  [CATEGORY_TYPE.DEPT_LEVEL1]: [],
  [CATEGORY_TYPE.DEPT_LEVEL2]: [],
  [CATEGORY_TYPE.TIMEKEEPING_TYPE]: [],
  [CATEGORY_TYPE.LEAVE_REASON_TYPE]: [],
};

const getCategoryOptionSlice = createSlice({
  name: "getCategoryOption",
  initialState,
  reducers: {
    getCategoryOptionStart: (
      state,
      action: PayloadAction<{
        categoryType: CATEGORY_TYPE;
        departmentCode?: string;
      }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getCategoryOptionSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state[action.payload.type] = action.payload.data;
    },
    getCategoryOptionFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },

    resetCategoryOption: () => {
      return { ...initialState };
    },
  },
});

export const {
  getCategoryOptionStart,
  getCategoryOptionSuccess,
  getCategoryOptionFailed,
  resetCategoryOption,
} = getCategoryOptionSlice.actions;

export default getCategoryOptionSlice.reducer;
